import React from 'react';

export const Spinner = () => {
  return (
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  );
};

export default Spinner;